import drawer from './state/drawer.js';
import lruDrawer from './state/lruDrawer.js';
import changesDrawer from './state/changesDrawer.js';
import network from './state/network.js';
import error from './state/error.js';
import success from './state/success.js';
import navigation from './state/navigation.js';
import endpoints from './state/endpoints.js';
import accountData from './state/accountData.js';
import selectedEndpoint from './state/selectedEndpoint.js';

const state = {
  drawer,
  lruDrawer,
  changesDrawer,
  selectedEndpoint,
  network,
  error,
  success,
  navigation,
  endpoints,
  accountData,
};

export default state;
